import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
//import Skeleton from "react-loading-skeleton";
import { ReactComponent as Chevron } from "../../assets/chevron.svg";
import { ReactComponent as AcademyHome } from "../../assets/Menu/academy-home.svg";
import { ReactComponent as CourseCatalogue } from "../../assets/Menu/course-catalogue.svg";
import { ReactComponent as CafeHome } from "../../assets/Menu/cafe-home.svg";
import { ReactComponent as ArticleCatalogue } from "../../assets/Menu/article-catalogue.svg";
import { ReactComponent as NewsCatalogue } from "../../assets/Menu/news-catalogue.svg";

type NavItemProps = {
  title: string;
  catalogue?: string;
  path: string;
  clickToCloseMenu: () => void;
};

const NavItem: React.FC<NavItemProps> = ({
  title,
  catalogue,
  path,
  clickToCloseMenu,
}) => {
  const dropContent = useRef<HTMLDivElement>(null);
  const { t, i18n } = useTranslation();
  // console.log("Current path:", path);
  // Toggle dropdown menu
  useEffect(() => {
    // Toggle hidden menu dropdown content when goes into ipad size
    window.addEventListener("resize", () => {
      if (window.innerWidth < 1024) {
        if (dropContent.current) dropContent.current.classList.add("hidden");
      } else {
        if (dropContent.current) dropContent.current.classList.remove("hidden");
      }
    });
  }, []);

  const handleClickDropBtn = () => {
    if (dropContent.current) dropContent.current?.classList.toggle("hidden");
  };

  //Relative Home Icons
  const homeIcon = (path: string) => {
    if (path === "academy") return <AcademyHome className="nav-icon" />;
    if (path === "cafe") return <CafeHome className="nav-icon" />;
  };

  const homeText = (path: string) => {
    if (path === "academy") return t("navbar.zeacademy-home");
    if (path === "cafe") return t("navbar.zecafe-home");
  };

  //Relative Catalogue Icons
  const catalogueIcon = (path: string, isNews?: boolean) => {
    if (path === "academy") return <CourseCatalogue className="nav-icon" />;
    if (path === "cafe" && !isNews)
      return <ArticleCatalogue className="nav-icon" />;
    if (path === "cafe" && isNews)
      return <NewsCatalogue className="nav-icon" />;
  };

  return (
    <div data-testid="header-dropdown" className="nav-item dropdown">
      <div onClick={handleClickDropBtn} className="drop-btn">
        {title}
        <Chevron className="icon mx-1" />
      </div>
      <div ref={dropContent} className="dropdown-content">
        <Link onClick={clickToCloseMenu} to={`/${i18n.language}/${path}`}>
          {" "}
          <div className="flex-r">
            {homeIcon(path)}
            {homeText(path)}
          </div>
        </Link>
        {path === "academy" && (
          <Link
            onClick={clickToCloseMenu}
            to={`/${i18n.language}/${path}/catalogue`}
          >
            <div className="flex-r">
              {catalogueIcon(path)}
              {catalogue}
            </div>
          </Link>
        )}
        {path === "cafe" && (
          <>
            <Link
              onClick={clickToCloseMenu}
              to={`/${i18n.language}/${path}/catalogue`}
            >
              <div className="flex-r">
                {catalogueIcon(path, false)}
                {t("navbar.article-catalogue")}
              </div>
            </Link>
            <Link
              onClick={clickToCloseMenu}
              to={`/${i18n.language}/${path}/news/catalogue`}
            >
              <div className="flex-r">
                {catalogueIcon(path, true)}
                {t("navbar.news-catalogue")}
              </div>
            </Link>
          </>
        )}
        {/* <Link to={`/${i18n.language}/cafe`}> {t("navbar.zecafe")}</Link> */}
      </div>
    </div>
  );
};

export default NavItem;
